import styled from "styled-components";
import Slider from "react-slick";
import { colors } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

export const StyledBrandGalleryHolder = styled.div`
  .slick-track {
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
`;

export const StyledSlider = styled(Slider)<{
  sliderWidth: string;
  variant: "small" | "large" | "fullPage" | "addRewardTray";
}>`
  width: ${(props) => props.sliderWidth};
  cursor: grab;
  .slick-dots {
    bottom: 10px;
    ${breakpoints.smUp} {
      bottom: ${(props) => (props.variant === "fullPage" ? "14px" : "10px")};
    }
    > li {
      height: 20px;
      width: 40px;
      > button {
        height: 20px;
        width: 40px;
        border-radius: 1px;
        padding: 0;
        border-top: 3px solid ${colors.black};
        &:before {
          padding: 0;
          height: 20px;
          width: 40px;
          border-radius: 1px;
          line-height: 0px !important;
          content: normal;
          border-top: 3px solid ${colors.black};
        }
      }
    }
  }

  .slick-dots li.slick-active button {
    border-top: 3px solid ${colors.coral};
    &:before {
      border-top: 3px solid ${colors.coral};
      opacity: 1;
    }
  }
`;

export const GalleryImageContainer = styled.div<{
  bgColor: string;
  isLocked: boolean;
  height: string;
  paddingBottom: string;
}>`
  width: 100%;
  height: ${(props) => props.height};
  padding: ${(props) => props.paddingBottom};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.bgColor};
  -webkit-tap-highlight-color: transparent;
  ${(props) =>
    props.isLocked &&
    `
      &:after {
        content: " ";
        display: block;
        position: absolute;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        background-color: ${colors.blackTransparent};
      }
    `}
  ${breakpoints.xsDown} {
    height: ${(props) => (props.paddingBottom ? props.paddingBottom : "410px")};
  }
`;
